import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'
import { prepareSearchParams } from '@/libs/helper'

const topic = `${Config.basePath}/conversation-summary`

export default {
  topicSummary(payload) {
    return Client.get(`${topic}`, {
      params: prepareSearchParams(payload),
    })
  },
  pushedToRageList(payload) {
    return Client.get(`${Config.basePath}/knowledge-record`, {
      params: prepareSearchParams(payload),
    })
  },
  deleteKnowledgeRecord(id) {
    return Client.delete(`${Config.basePath}/knowledge-record/delete/${id}`)
  },
  downloadTopicSummary(payload) {
    return Client.get(`${topic}/download`, {
      params: payload,
    })
  },
  enable(payload) {
    return Client.put(`${topic}/enable`, {
      ...payload,
    })
  },
  destroyTopicSummary(id) {
    return Client.delete(`${topic}/delete/${id}`)
  },
  groupTopicSummary(payload) {
    return Client.get(`${topic}/group-topic`, {
      params: prepareSearchParams(payload),
    })
  },
  downloadFrequentlyTopicSummary(payload) {
    return Client.get(`${topic}/download-group-topic`, {
      params: payload,
    })
  },
  conversationSummary(payload) {
    return Client.get(`${Config.basePath}/conversation-summary`, {
      params: payload,
    })
  },
  downloadConversationSummary(payload) {
    return Client.get(`${Config.basePath}/conversation-summary/download`, {
      params: payload,
    })
  },
  updateConversationSummary(id, payload) {
    return Client.put(`${Config.basePath}/conversation-summary/update/${id}`, {
      ...payload,
    })
  },
  updateKnowledgeRecord(id, payload) {
    return Client.put(`${Config.basePath}/knowledge-record/update/${id}`, {
      ...payload,
    })
  },
}
